import { render } from "./LeaveSlackNotificationConfiguration.vue?vue&type=template&id=bbf3005a&scoped=true"
import script from "./LeaveSlackNotificationConfiguration.vue?vue&type=script&lang=js"
export * from "./LeaveSlackNotificationConfiguration.vue?vue&type=script&lang=js"

import "./LeaveSlackNotificationConfiguration.vue?vue&type=style&index=0&id=bbf3005a&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bbf3005a"]])

export default __exports__